import { posApi } from "../api/client";
import {
  getCachedCustomerByPhone,
  saveCustomerToReferenceCache,
} from "./offline-sync/reference-cache";
import type { LocalOrderCustomerSnapshot } from "./offline-sync/types";

function isOnline(): boolean {
  return typeof navigator === "undefined" || navigator.onLine;
}

export function resolveEffectiveCustomerId(
  customerId?: string,
  snapshot?: LocalOrderCustomerSnapshot,
): string | undefined {
  return (
    customerId?.trim() ||
    snapshot?.customerId?.trim() ||
    undefined
  );
}

export async function resolveCustomerLoyaltyBalance(input: {
  branchId: string;
  customerId?: string;
  customerSnapshot?: LocalOrderCustomerSnapshot;
  phone?: string;
  firstName?: string;
  lastName?: string;
}): Promise<number> {
  const customerId = resolveEffectiveCustomerId(
    input.customerId,
    input.customerSnapshot,
  );
  const phone = input.phone?.trim();

  if (customerId && isOnline()) {
    try {
      const balance = await posApi.getCustomerLoyaltyBalance(customerId);
      if (phone) {
        try {
          await saveCustomerToReferenceCache(input.branchId, {
            customerId,
            phone,
            firstName: input.firstName,
            lastName: input.lastName,
            loyaltyPoints: balance,
          });
        } catch {
          // cache update is best-effort
        }
      }
      return balance;
    } catch {
      // fall back to local cache
    }
  }

  if (phone) {
    const cached = await getCachedCustomerByPhone(input.branchId, phone);
    return cached?.loyaltyPoints ?? 0;
  }

  return 0;
}
